import React, { Fragment, useEffect, useState } from "react";
import { set_order_detail } from "../../../../redux/actions/OrdersAction";
import { connect } from "react-redux";
import { apiJson } from "../../../../api/Api";
import { toast } from "react-toastify";

import ClipLoader from "react-spinners/ClipLoader";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./orderheader.scss";
import { AiFillCheckCircle } from "react-icons/ai";
import { BiError } from "react-icons/bi";
import { format } from "date-fns";
import Select from "react-select";

const filters = [
  [{ value: "processing", label: "processing" }],
  [
    { value: "processing", label: "processing" },
    { value: "rejected", label: "rejected" },
  ],
  [{ value: "shipped", label: "shipped" }],
  [{ value: "delivered", label: "delivered" }],
  [
    { value: "ready_for_collection", label: "Ready For Collection" }
  ],
  [
    { value: "ready_for_collection", label: "Ready For Collection" },
    { value: "collected", label: "Collected" },
  ]
];

const OrderHeader = (props) => {
  const [values, setValues] = useState({});
  const [filterOption, setFilterOption] = useState({});
  const [filterValue, setFilterValue] = useState({});
  const [noFilter, setNoFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    setValues(props.orderDetail);
    if (props.orderDetail?.shipment?.status) {
      props.orderDetail.shipment.status === "pending"
        ? props.vendorStore.can_reject_order
          ? setFilterOption(filters[1])
          : setFilterOption(filters[0])
        : props.orderDetail.shipment.status === "processing"
          ? props.orderDetail.is_delivery == 1 ? setFilterOption(filters[2]) : setFilterOption(filters[4])
          : props.orderDetail.shipment.status === "shipped"
            ? setFilterOption(filters[3])
            :
            props.orderDetail.shipment.status === "ready_for_collection"
            ? setFilterOption(filters[5])
            : setNoFilter(true);
      setFilterValue({
        value: props.orderDetail.shipment.status,
        label: props.orderDetail.shipment.status,
      });
    } else if (!props.orderDetail?.shipment?.status) {
      if (props.orderDetail?.services[0]?.status) {
        props.orderDetail.services[0].status === "pending"
          ? props.vendorStore.can_reject_order
            ? setFilterOption(filters[0])
            : setFilterOption(filters[0])
          : props.orderDetail.services[0].status === "processing"
            ? setFilterOption(filters[3])
            : setNoFilter(true);
        setFilterValue({
          value: props.orderDetail.services[0].status,
          label: props.orderDetail.services[0].status,
        });
      }
    }
    // eslint-disable-next-line
  }, [props.orderDetail]);

  const handleUpdate = () => {
    if (
      props.orderDetail.shipment?.status
        ? props.orderDetail.shipment?.status !== filterValue.value
        : props.orderDetail?.services[0]?.status !== filterValue.value
    ) {
      setLoading(true);
      apiJson.orders
        .updateOrderStatus(props.orderDetail.id, {
          order: {
            status: filterValue.value,
          },
        })
        .then((response) => {
          if (response.success) {
            props.set_order_detail({ orderDetail: response.data });
            message = "Updated Successfully";
            showSuccess();
            setLoading(false);
          } else if (!response.status) {
            setLoading(false);
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          } else {
            setLoading(false);
            if (response.status >= 400 && response.status < 500) {
              message = response.message
                ? response.message
                : response.errors
                  ? response.errors
                  : "something went wrong";
              showError();
            } else {
              message = response.message
                ? response.message !== ""
                  ? response.message
                  : "something went wrong"
                : "something went wrong";
              showError();
            }
          }
        });
    }
  };

  const handleSelect = (e) => {
    setFilterValue(e);
  };

  return (
    <div className="order-header-desktop">
      <div className="wrapper">
        {values && (values.address || values.pickup_address) && (
          <Fragment>
            <Row className="header g-0 justify-content-start pb-3">
              <div className="order-number">{values.id}</div>
              <div className="gray-text placed-on">
                Placed on{" "}
                {format(Date.parse(values.created_at), "dd MMM yyy p")}
              </div>
            </Row>
            <Row className="detail-col g-0 pt-2">
              <Col md={6} className="address-col py-1">
                {
                  values.address ?
                    <>
                      <div className="title">SHIPPING ADDRESS</div>
                      <div className="name py-2">
                        {values.address.first_name
                          ? values.address.first_name
                          : ""}
                      </div>
                      <div className="address">{values.address.address1}</div>
                      <div className="address">{values.address.address2}</div>
                    </>
                    :
                    <>
                      <div className="title">PICKUP ADDRESS</div>
                      <div className="address">{values.pickup_address?.store_address}</div>
                      <div className="address"><a href={values.store_address?.google_map_link} target="_blank">View on map</a></div>
                    </>
                }
              </Col>

              <Col md={6} className="phone-col pl-2">
                <div className="title">MOBILE NUMBER</div>
                <div className="phone-verification-col d-flex align-items-center">
                  <div className="mobile-number">
                    {values.address ? values.address.contact_number : values?.pickup_customer_name}
                  </div>
                  <div className="verified-mark d-flex align-items-center">
                    {values.address && (
                      values.address.contact_number_verified ? (
                        <Fragment>
                          <span className="green-checkbox mr-1">
                            <AiFillCheckCircle />
                          </span>
                          <span className="gray-text">Verified</span>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <span className="green-checkbox mr-1">
                            <BiError />
                          </span>
                          <span className="gray-text">Not Verified</span>
                        </Fragment>
                      )
                    )
                    }
                  </div>
                </div>

                {values.dues_paid && values.payment_methods.cash_on_delivery && (
                  <>
                    <div className=" mt-2 fs-size title">
                      Cash On Delivery Transcation
                    </div>
                    <div className="phone-verification-col d-flex align-items-center">
                      <div className="mobile-number">Completed</div>
                    </div>
                  </>
                )}

                <div className="status-col d-flex flex-column justify-content-end align-items-end">
                  <div className="status d-flex justify-content-center align-items-center">
                    <span
                      className="text"
                      style={{ textTransform: "capitalize" }}
                    >
                      {props.orderDetail.shipment?.status
                        ? props.orderDetail.shipment?.status.includes("_")
                          ? props.orderDetail.shipment?.status.replace("_", " ")
                          : props.orderDetail.shipment?.status
                        : props.orderDetail?.services[0]?.status}
                    </span>
                  </div>
                  {!noFilter && (
                    <div className="update-status-col d-flex align-items-center">
                      <div className="select">
                        <Select
                          value={filterValue}
                          onChange={handleSelect}
                          options={filterOption}
                          className="filter"
                          classNamePrefix="control"
                          isSearchable={false}
                          placeholder="Select Status"
                        />
                      </div>
                      <button
                        className="update-button"
                        type="button"
                        onClick={handleUpdate}
                        disabled={loading}
                      >
                        {loading ? (
                          <ClipLoader color="#000" loading size={20} />
                        ) : (
                          "Update Status"
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Fragment>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    vendorStore: state.vendorStore.vendorStore,
  };
};

const mapDispatchToProps = { set_order_detail };

export default connect(mapStateToProps, mapDispatchToProps)(OrderHeader);
